// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';

const wiz = new Wiz({ appId: 'page.servers.detail', namespace: 'servers.detail' });
@AngularComponent({
  selector: 'wiz-page-servers-detail',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class PageServersDetailComponent {}

export default PageServersDetailComponent;
